import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssinaturaService } from '../assinaturas/assinatura.service';

@Component({
  selector: 'app-validar-assinatura',
  templateUrl: './validar-assinatura.component.html',
  styleUrls: ['./validar-assinatura.component.css'],
  providers: [AssinaturaService]
})
export class ValidarAssinaturaComponent implements OnInit {
  public carregando: boolean = true;
  public erro: boolean = false;
  public mensagemErro: string = '';
  public dados: any = null;

  constructor(
    private route: ActivatedRoute,
    private assinaturaService: AssinaturaService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.verificar(id);
      } else {
        this.carregando = false;
        this.erro = true;
        this.mensagemErro = 'Identificador da assinatura não informado.';
      }
    });
  }

  verificar(id: number): void {
    this.carregando = true;
    this.erro = false;
    this.dados = null;

    this.assinaturaService.verificarAssinatura(id)
      .then((dados) => {
        this.dados = dados;
        this.carregando = false;
      })
      .catch((error) => {
        this.carregando = false;
        this.erro = true;
        this.mensagemErro = (error && error.msg) ? error.msg : 'Assinatura não encontrada.';
      });
  }

  statusClasse(): string {
    if (!this.dados) return '';
    return this.dados.valida ? 'green darken-1' : 'red darken-1';
  }

  statusIcone(): string {
    if (!this.dados) return 'help';
    return this.dados.valida ? 'check_circle' : 'cancel';
  }

  tipoLabel(): string {
    if (!this.dados) return '';
    return this.dados.tipo === 'govbr' ? 'GOV.BR' : 'Interna';
  }

  formatarData(data: string): string {
    if (!data) return '-';
    const partes = data.split(/[- :]/);
    if (partes.length < 5) return data;
    return `${partes[2]}/${partes[1]}/${partes[0]} às ${partes[3]}:${partes[4]}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/validar-assinatura/validar-assinatura.component.ts